import React from 'react'

import { getAspectRatioPadding } from './utils/getAspectRatioPadding'

import { TIconProps } from './iconProps'

const IconHseLogo: React.FC<TIconProps> = (props) => {
  return (
    <div style={props.style} className={`select-none ${props.className || 'w-24'}`} onClick={props.onClick}>
      <div className="relative h-0" style={getAspectRatioPadding('101/40')}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-full left-0 top-0 absolute"
          viewBox="0 0 101 40"
          id="hse_logo"
        >
          <g fill="none" fillRule="evenodd" className="pointer-events-none">
            <path
              fill="currentColor"
              d="M99 30.8V38c-2.646-.246-19.062-1.66-26.387-2.036V4.037c7.31-.403 21.083-1.554 25.882-1.993v7.183c-6.126.321-12.355.64-18.551.906v6.783c5.045-.062 10.087-.124 15.126-.217v6.608c-5.038-.093-10.081-.156-15.126-.217v6.777c6.366.274 12.768.603 19.056.933zm-31.49-4.616c0-7.444-8.488-8.917-14.404-9.623-2.513-.3-8.865-1.244-8.865-3.436 0-1.774 2.32-3.245 7.371-3.245 3.935 0 7.28.901 10.325 2.802.428.266.985.179 1.311-.205l3.594-4.227c-4.429-3.121-9.649-4.24-14.745-4.24-8.776 0-15.414 3.24-15.414 9.241 0 6.749 7.675 8.353 12.498 9.094 4.505.692 10.765.957 10.765 3.882 0 2.673-5.017 3.892-8.718 3.892-2.755 0-5.5-.63-9.485-2.528-.416-.198-.912-.09-1.21.26l-3.69 4.34c5.123 2.855 11.05 3.796 14.553 3.796 8.145 0 16.115-3 16.115-9.803zm-43.76-9.241c-4.687-.052-9.37-.105-14.051-.185V2.704C7.13 2.487 4.564 2.258 2 2v36c2.565-.258 5.131-.488 7.698-.704V23.242c4.682-.08 9.365-.132 14.051-.184v13.258c2.443-.135 4.887-.255 7.33-.353V4.037c-2.443-.098-4.887-.218-7.33-.353v13.259z"
            />
          </g>
        </svg>
      </div>
    </div>
  )
}
export default IconHseLogo
